export const REQUEST_ENTITY_TOO_LARGE_ERROR_CODE = 413;

export function isRequestEntityTooLargeError(response) {
  return response instanceof Response && response.status === REQUEST_ENTITY_TOO_LARGE_ERROR_CODE;
}
